import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    description: 'integrations page header',
    defaultMessage: 'Integration Partners',
    id: 'at/YhL',
  },
  subText: {
    description: 'integrations.subText',
    defaultMessage:
      "We integrate natively with the products below. We're always looking for more ways to streamline your business, so please feel free to <link>suggest more</link> integrations!",
    id: 'vdeZ6r',
  },
  mailChimp: {
    description: 'integrations description of mailChimp',
    defaultMessage: 'Our native MailChimp integration automatically creates new MailChimp email subscribers when new orders are imported.',
    id: 'iJ96GU',
  },
  mcSubscriberData: {
    description: 'subscriber page will update with mailchimp',
    defaultMessage: 'The following subscriber data will be created or updated with any MailChimp list you prefer:',
    id: 'WZAhhf',
  },
  emailAddress: {
    description: 'mailChimp subscriber email address',
    defaultMessage: 'Email address',
    id: 'xRKdlz',
  },
  firstAndLastName: {
    description: 'mailChimp subscriber first and last name',
    defaultMessage: 'First & last name',
    id: 'x6l8FZ',
  },
  lastOrderDate: {
    description: 'mailChimp subscriber last order date',
    defaultMessage: 'Last Order Date',
    id: 'YYbhyK',
  },
  newField: {
    description: 'mailChimp new subscriber field',
    defaultMessage: '(a new subscriber field)',
    id: 'My4W4T',
  },
  newGroup: {
    description: 'mailChimp new subscriber group',
    defaultMessage: '(a new subscription group)',
    id: 'Gah1po',
  },
  lastOrderAmount: {
    description: 'mailChimp subscriber last order amount',
    defaultMessage: 'Last Order Amount',
    id: 'ZaTU1F',
  },
  customerMarketplaces: {
    description: 'mailChimp customer marketplaces',
    defaultMessage: 'Marketplace(s) from which the Customer has ordered',
    id: 'PvpEt1',
  },
  storeName: {
    description: 'mailChimp subscriber Store Name from last purchase',
    defaultMessage: 'Store Name from last purchase',
    id: '+LbkEC',
  },
  zipcode: {
    description: 'mailChimp subscriber zipcode',
    defaultMessage: 'Zipcode',
    id: 'eRsJsZ',
  },
  city: {
    description: 'mailChimp subscriber city',
    defaultMessage: 'City',
    id: 'n6wvkV',
  },
  state: {
    description: 'mailChimp subscriber state',
    defaultMessage: 'State',
    id: 'Kvm55o',
  },
  countryCode: {
    description: 'mailChimp subscriber country code',
    defaultMessage: 'Country Code',
    id: 'GtuGDo',
  },
  onlyNewSubscribers: {
    description: 'mailChimp does not create customer history. only for new customers',
    defaultMessage: 'At this time, we do not create subscribers for customer history, only new customers moving forward',
    id: 'MhEoIJ',
  },
  connectMC: {
    description: 'connect to mailchimp header',
    defaultMessage: 'Connect to MailChimp',
    id: '/57PhD',
  },
  signIn: {
    description: 'sign in to mailChimp account',
    defaultMessage: 'Click the button below to sign in to your MailChimp account.',
    id: 'vfXEzR',
  },
  loginMC: {
    description: 'login to mailchimp',
    defaultMessage: 'Login to MailChimp',
    id: 'EF57LZ',
  },
  eDesk: {
    description: 'eDesk can be integrated with SS',
    defaultMessage:
      'Your eDesk store can be integrated with ShipStation in just minutes. To grant ShipStation access to your eDesk account, please follow the instructions below.',
    id: 'EHpcj/',
  },
  loginEDesk: {
    description: 'login to eDesk account',
    defaultMessage: 'Log into your eDesk account.',
    id: '45NrGh',
  },
  path: {
    description: 'directions on path to follow to set up eDesk',
    defaultMessage: 'Go to Avatar > Settings > Integrations > ShipStation.',
    id: 'a13OnH',
  },
  copyPaste: {
    description: 'directions on how to copy api keys for edesk',
    defaultMessage: 'Copy and paste the ShipStation API Key and Secret into the corresponding fields.',
    id: 'NO6AiB',
  },
  saveChanges: {
    description: 'click to save changes direction for edesk setup',
    defaultMessage: 'Click Save Changes.',
    id: '8xlz/W',
  },
  clickHere: {
    description: 'integrations.clickHere',
    defaultMessage: 'For more information on how to find your API key in ShipStation, click <a>here</a>.',
    id: 'SwkPhE',
  },
  gorgias: {
    description: 'integrations.gorgias',
    defaultMessage:
      'Display order and fulfillment information by linking ShipStation to Gorgias. For info on how to set up your Gorgias account with ShipStation, click <a>here</a>',
    id: 'YjkEia',
  },
  shipperHQ: {
    description: 'shipperHQ integrations subtext',
    defaultMessage: 'Connect your ShipperHQ account and view detailed shipping data for your orders inside ShipStation. <a>Learn more</a>',
    id: 'JwwqgQ',
  },
  googleNoConnectionsMarketing: {
    description: 'google integration no connection learn more text',
    defaultMessage:
      'Shipping speeds are a critical factor in customers’ purchase decisions. At no cost, link your ShipStation account to Google Merchant Center and let Google calculate shipping speeds on your behalf.',
    id: 'ddNvGf',
  },
  googleNoConnectionsTechExplanation: {
    description: 'google integration no connection explanation',
    defaultMessage:
      'Google does this by using your order tracking history data provided by ShipStation, paired with its machine learning capabilities to show more accurate product and location-specific delivery times to your customers.',
    id: 'i9mBK+',
  },
  googleNoConnectionsLink: {
    description: 'google integration no connection link',
    defaultMessage: '<b><link>Learn more about the Google Shipping Data Integration</link></b>',
    id: 'pYIGq3',
  },
  googleBenifitsHeader: {
    description: 'google integration benefits header',
    defaultMessage: 'Benefits of Google Shipping Data',
    id: 'VwZ5f+',
  },
  googleAccurateSpeed: {
    description: 'google integration accurate speeds',
    defaultMessage:
      '<b>Accurate Speeds:</b> The product and location-specific delivery estimates will show up on Google surfaces like Search and Images in gray text, for example, "Free delivery by Fri, Aug 11." Showing faster speeds tends to drive better performance.',
    id: 'R2gDXB',
  },
  googleImportantBadges: {
    description: 'google integration important badges',
    defaultMessage:
      '<b>Important Badges:</b> The “Free & Fast Shipping” and “Top Quality Store” badges will also be easier to obtain, as they are meaningfully influenced by quoted shipping speed.',
    id: 'E9gukJ',
  },
  googleRankBoost: {
    description: 'google rank boosts',
    defaultMessage:
      '<b>Rank Boosts:</b> Quoted shipping speed is used in some of Google’s ranking models. If you make fast delivery promises that Google has high confidence in, your products may be shown more prominently than products with slower speeds, with lower confidence scores, or without a shipping speed.',
    id: 'PAr6R4',
  },
  googleDataSharingHeader: {
    description: 'google data sharing header',
    defaultMessage: 'Data Shared with Google',
    id: 'STDoNm',
  },
  googleDataSharingIntro: {
    description: 'google data sharing intro',
    defaultMessage:
      'While connected, ShipStation will regularly send Google your order tracking history for the stores that you have selected. Order tracking history is your historical data describing…',
    id: '6TYFSo',
  },
  googleIncludedDataOrder: {
    description: 'google integration tracked data explanation for order info',
    defaultMessage: 'Order information, including order ID, order creation time, delivery postal code, and region code',
    id: 'v1B0dI',
  },
  googleDataSharing1: {
    description: 'google integration tracked data',
    defaultMessage: 'The parcels you have shipped',
    id: 'QoHRs2',
  },
  googleDataSharing2: {
    description: 'google integration tracked data',
    defaultMessage: 'The products those parcels contained',
    id: 'jPVv+v',
  },
  googleDataSharing3: {
    description: 'google integration tracked data',
    defaultMessage: 'Their carriers and tracking numbers',
    id: 'KWLEYo',
  },
  googleDataSharing4: {
    description: 'google integration tracked data',
    defaultMessage: 'Their origin and destination postal codes',
    id: 'ub9QMw',
  },
  googleDataSharing5: {
    description: 'google integration tracked data',
    defaultMessage: 'The key timestamps associated with fulfillment',
    id: 'ISYrfX',
  },
  makeCustomerFeelBetter: {
    description: 'this is the data that google will not track',
    defaultMessage:
      'To protect your customers’ personal information, tracking history does not include any names, street addresses, email addresses, or phone numbers.',
    id: 'H8LuKd',
  },
  googleIncludedDataShippingCostOrder: {
    description: 'google integration tracked data explanation for shipping cost',
    defaultMessage: 'Shipping cost charged to the buyer',
    id: 'LH5OAd',
  },
  googleIncludedShippingInfo: {
    description: 'google integration tracked data explanation for shipping info',
    defaultMessage:
      'Shipping information, including the carrier, tracking number, origin, destination, and shipping times for each shipment associated with the order',
    id: 'kQ9TBa',
  },
  googleIncludedDataOrderLineItems: {
    description: 'google integration tracked data explanation for order line item info',
    defaultMessage: 'Order line item information, including the products in the order',
    id: 'j0/ZIP',
  },
  googleConnectStores: {
    description: 'call to action to connect stores',
    defaultMessage: 'Select which stores will share shipping data with Google Merchant Center:',
    id: 'uiQkm/',
  },
  googleIncludedShippedParcels: {
    description: 'google integration tracked data explanation parcels shipped',
    defaultMessage: 'The parcels you have shipped',
    id: 'AD9W0N',
  },
  googleIncludedParcelsContents: {
    description: 'google integration tracked data explanation parcels contents',
    defaultMessage: 'The products those parcels contained',
    id: '9IcDTY',
  },
  googleIncludedCarrierInfo: {
    description: 'google integration tracked data explanation carrier info',
    defaultMessage: 'Their carriers and tracking numbers',
    id: '2EgimS',
  },
  googleIncludedZipInfo: {
    description: 'google integration tracked data explanation zip info',
    defaultMessage: 'Their origin and destination postal codes',
    id: 'aEPD7I',
  },
  googleIncludedTimestampInfo: {
    description: 'google integration tracked data explanation timestamp info',
    defaultMessage: 'The key timestamps associated with fulfillment',
    id: '3/exqL',
  },
  googlePrivacyPolicy: {
    description: 'google integration tracked data explanation for order line item info',
    defaultMessage:
      'This historical order tracking data will initially include <b>120</b> days of history from the stores selected below. Shipstation will send updated history <b>daily</b>. This data will also be used to make Google’s proprietary machine learning models better for all retailers, including your business. But Google will never share your data with any other retailer outside of aggregated, anonymized benchmarks like the ones in the <a1>Shopping experience scorecard</a1>. For more information on Google’s privacy policies click <a2>here</a2>.',
    id: 'jYhO6S',
  },
  googleProductMatching: {
    description: 'requirement for matching products with google integration',
    defaultMessage:
      'Note that Google will discard history data for any product that it can’t match to a product in your Google feed. To best facilitate this matching, consider using the same value for <code>productId</code> on Shipstation (<a1>link</a1>) that you use for <code>[id]</code> in Google Merchant Center (<a2>link</a2>)',
    id: 'Dx0gpk',
  },
  connectAStore: {
    description: 'shipperHQ integrations connect a store button',
    defaultMessage: 'Connect a store',
    id: 'hLDT4E',
  },
  connectAStoreInGoogle: {
    description: 'google integrations connect a store button',
    defaultMessage: '<b>Connect</b>',
    id: 'rqYtrz',
  },
  googleConnectedBanner: {
    description: 'google integration connected banner',
    defaultMessage: '<b>Your account is connected to Google Merchant Center.</b> To disconnect, click <a>here</a>',
    id: 'S3NRmd',
  },
  googleMerchantConnection: {
    description: 'google integration explanation text',
    defaultMessage:
      'Your ShipStation and Google Merchant Center accounts are linked, and you have opted-in to Google-calculated performance verification and delivery time predictions on Google surfaces like Search, Images, and YouTube. ',
    id: 'FZEO40',
  },
  defineConnection: {
    description: 'shipperHQ integrations connect a store modal header',
    defaultMessage: 'Define Connection',
    id: 'r51msl',
  },
  store: {
    description: 'shipperHQ store dropdown',
    defaultMessage: 'Store',
    id: 'j/BNm9',
  },
  accessToken: {
    description: 'shipperHQ access token input',
    defaultMessage: 'Access Token',
    id: 'Pqt2KT',
  },
  webhooks: {
    description: 'webhooks header',
    defaultMessage: 'Webhooks',
    id: 'I40Vb0',
  },
  webhookText: {
    description: 'webhook description of how they can be used with SS',
    defaultMessage:
      'Webhooks allow your web application to be notified of events in ShipStation as soon as they happen. Used alongside <a>our Rest API</a>, they are a great way to share information with your custom application.',
    id: 'Ox+rX4',
  },
  quickbooks: {
    description: 'connect to quickbooks',
    defaultMessage: 'Connect to QuickBooks',
    id: 'SAlv3f',
  },
  quickbooksClick: {
    description: 'sign into quickbooks button',
    defaultMessage: 'Click the button below to sign in to your QuickBooks account.',
    id: 'ArZgEF',
  },
  zapier: {
    description: 'zapier descrition',
    defaultMessage:
      "Zapier allows you to seamlessly connect data between web apps. We built our Zapier integration to give you maximum flexibility with hundreds of other productivity tools. A number of pre-built 'Zaps' are listed below, but you can also create your own at Zapier.com.",
    id: '+MO8nt',
  },
  addWebhook: {
    description: 'add a webhook',
    defaultMessage: 'Add a Webhook',
    id: '2e+PLQ',
  },
  nameDescription: {
    description: 'webhook input field placeholder for name/description',
    defaultMessage: 'Name / Description',
    id: 'I7HXcr',
  },
  sendToURL: {
    description: 'webhook input field placeholder for send to url',
    defaultMessage: 'Send to URL...',
    id: 't5J6oG',
  },
  saveButton: {
    description: 'webhook save button',
    defaultMessage: 'Save',
    id: 'vr0SI6',
  },
  cancelButton: {
    description: 'webhook cancel button',
    defaultMessage: 'Cancel',
    id: 'quYfe5',
  },
  editButton: {
    description: 'webhook edit button',
    defaultMessage: 'Edit',
    id: 'YKnqle',
  },
  removeButton: {
    description: 'remove webhook button',
    defaultMessage: 'Remove',
    id: 'V6PI9d',
  },
  allStores: {
    description: 'webhook store dropdown default selection',
    defaultMessage: '(All Stores)',
    id: '/0wWd7',
  },
  onNewOrders: {
    defaultMessage: 'webhook dropdown hook type on new orders',
    id: 'MwD/aw',
    description: 'sellerSettings.integrations.onNewOrders',
  },
  onNewItems: {
    defaultMessage: 'webhook dropdown hook type On New Items',
    id: 'HQasaC',
    description: 'sellerSettings.integrations.onNewItems',
  },
  onOrdersShipped: {
    defaultMessage: 'webhook dropdown hook type On Orders Shipped',
    id: 'VxSv/Y',
    description: 'sellerSettings.integrations.onOrdersShipped',
  },
  onItemsShipped: {
    defaultMessage: 'webhook dropdown hook type On Items Shipped',
    id: 'KNW5tv',
    description: 'sellerSettings.integrations.onItemsShipped',
  },
  onBatchProcessedV2: {
    defaultMessage: 'webhook dropdown hook type V2 On Batch Processed',
    id: 'rStzpv',
    description: 'sellerSettings.integrations.onBatchProcessedV2',
  },
  onTrackEventV2: {
    defaultMessage: 'webhook dropdown hook type V2 On Track Event',
    id: '7OHAY/',
    description: 'sellerSettings.integrations.onTrackEventV2',
  },
  onNewOrderCreatedV2: {
    defaultMessage: 'webhook dropdown hook type V2 On New Order Created',
    id: 'wqswTV',
    description: 'sellerSettings.integrations.onNewOrderCreatedV2',
  },
  onNewLabelCreatedV2: {
    defaultMessage: 'webhook dropdown hook type V2 On New Label Created',
    id: '83uClb',
    description: 'sellerSettings.integrations.onNewLabelCreatedV2',
  },
  onFulfillmentsShippedV2: {
    defaultMessage: 'webhook dropdown hook type V2 On Fulfillments Shipped',
    id: 'Qs4g41',
    description: 'sellerSettings.integrations.onFulfillmentsShippedV2',
  },
  onFulfillmentsRejectedV2: {
    defaultMessage: 'webhook dropdown hook type V2 On Fulfillments Rejected',
    id: '2FE8VJ',
    description: 'sellerSettings.integrations.onFulfillmentsRejectedV2',
  },
  tooltip: {
    description: 'webhook popup to confirm deletion of webhook',
    defaultMessage: 'Remove this Webhook?',
    id: 'XUUXri',
  },
  remove: {
    description: 'remove webhook',
    defaultMessage: 'Yes, remove it',
    id: '/f1qc1',
  },
  cannotBeEmpty: {
    description: 'tooltip for empty input in webhooks',
    defaultMessage: 'This field is required',
    id: '2ZTW3W',
  },
  mustBeValidUrl: {
    description: 'must be a valid url for webhooks input field',
    defaultMessage: 'Must be a valid url',
    id: 'WM+H0Y',
  },
  edeskLogo: {
    description: 'EDesk Logo',
    defaultMessage: 'EDesk Logo',
    id: '4jynjc',
  },
  gorgiasLogo: {
    description: 'Gorgias Logo',
    defaultMessage: 'Gorgias Logo',
    id: '65VlfG',
  },
  mailChimpLogo: {
    description: 'MailChimp Logo',
    defaultMessage: 'MailChimp Logo',
    id: 'oALoAr',
  },
  quickBooksLogo: {
    description: 'QuickBooks Online Logo',
    defaultMessage: 'QuickBooks Online Logo',
    id: '7XwuAD',
  },
  webhooksLogo: {
    description: 'Webhooks Logo',
    defaultMessage: 'Webhooks Logo',
    id: '8nrwNu',
  },
  zapierLogo: {
    description: 'Zapier Logo',
    defaultMessage: 'Zapier Logo',
    id: 'IhBdNl',
  },
  returnRabbitLogo: {
    description: 'ReturnRabbit Logo',
    defaultMessage: 'ReturnRabbit Logo',
    id: 'iGgCG1',
  },
  shipperHQLogo: {
    description: 'ShipperHQ Logo',
    defaultMessage: 'ShipperHQ Logo',
    id: 'Fgvl1l',
  },
  googleLogo: {
    description: 'Google Logo',
    defaultMessage: 'Google Logo',
    id: 'umG2Z+',
  },
  santosTestLogo: {
    description: 'Santos-test Logo',
    defaultMessage: 'Santos-test Logo',
    id: 'J175wG',
  },
  santosTestName: {
    description: 'Santos-test',
    defaultMessage: 'Santos-test',
    id: 'ngpFR5',
  },
  reconnectViaSantosTest: {
    description: 'Reconnect via santos test info title',
    defaultMessage: 'Reconnect via Santos-test',
    id: 'kazgkh',
  },
  reconnectToSantosTestInstructions: {
    description: 'Reconnect via santos test instructions',
    defaultMessage: 'To reconnect, you need to reauthorize the connection(s) via Santos-test.',
    id: 'W6nzuE',
  },
  santosTestConnectedDescription: {
    description: 'Santos test integration description text',
    defaultMessage:
      'This ShipStation account is actively connected to Santos-test. Through this connection, orders will be created in this account.',
    id: 'qwWzQ5',
  },
  santosTestDisconnectedDescription: {
    description: 'Santos test integration description text',
    defaultMessage: 'This ShipStation account has been disconnected from “Santos-test.”',
    id: 'CN8WQT',
  },
  failedToDeleteSantosTestConnection: {
    description: 'santos test connection failed to delete message',
    defaultMessage: 'Unable to delete Santos-test connection, please try again.',
    id: 'mybpmn',
  },
  santosTestDeleteWarningMessage: {
    description: 'santos test connection Delete Warning Message',
    defaultMessage:
      'Confirm that you want to disconnect your ShipStation account from all active Santos-test connections. Imported data will remain on ShipStation, and you will have to re-initiate any connections from Santos-test to undo this change.',
    id: 'ZUYiIx',
  },
  deleteSantosTestConnectionModalTitle: {
    description: 'santos test connection Delete Modal Title',
    defaultMessage: 'Confirmation',
    id: 'JMx0O8',
  },
  disconnectFromSantosTest: {
    description: 'disconnect from Santos Test button label',
    defaultMessage: 'Disconnect from Santos-test',
    id: 'NmhWLF',
  },
  continue: {
    description: 'continue',
    defaultMessage: 'Continue',
    id: '9ytfZe',
  },
  shipperHQName: {
    description: 'ShipperHQ',
    defaultMessage: 'ShipperHQ',
    id: 'dVzeqC',
  },
  googleHeaderName: {
    description: 'Google header',
    defaultMessage: 'Utilize Google Shipping Data to calculate shipping speeds',
    id: 'dJ1bsw',
  },
  cancel: {
    description: 'cancel button Logo',
    defaultMessage: 'Cancel',
    id: 'tqUJ3Z',
  },
  saveConnection: {
    description: 'save connection button',
    defaultMessage: 'Save Connection',
    id: 'jMfi+n',
  },
  delete: {
    description: 'delete',
    defaultMessage: 'Delete',
    id: 'qpFbwr',
  },
  deleting: {
    description: 'deleting',
    defaultMessage: 'Deleting',
    id: 'Ti+WoP',
  },
  codeIsUnique: {
    description: 'shipperHQ code is unique message',
    defaultMessage: 'This code is unique to this store connection. <a>Learn more</a>',
    id: 'ZOLHSx',
  },
  storeConnections: {
    description: 'shipperHQ store connections column header',
    defaultMessage: 'Store Connections',
    id: 'Zgl1Kx',
  },
  actions: {
    description: 'shipperHQ actions column header',
    defaultMessage: 'Actions',
    id: 'W1zP/6',
  },
  edit: {
    description: 'shipperHQ edit button',
    defaultMessage: 'Edit',
    id: 'Cf4Wye',
  },
  failedToSaveShipperHQConnection: {
    description: 'shipperHQ connection failed to save message',
    defaultMessage: 'Unable to save ShipperHQ connection, please try again.',
    id: 'ETHuoc',
  },
  failedToDeleteShipperHQConnection: {
    description: 'shipperHQ connection failed to delete message',
    defaultMessage: 'Unable to delete ShipperHQ connection, please try again.',
    id: 'hKn0vX',
  },
  deleteConnection: {
    description: 'shipperHQ delete connection modal header',
    defaultMessage: 'Delete Connection?',
    id: 'hG28LO',
  },
  deleteConnectionWarning: {
    description: 'shipperHQ delete connection modal body text',
    defaultMessage:
      'Are you sure you want to delete this store’s ShipperHQ connection? You will need to create a new connection in order to undo this change.',
    id: '7NeoSe',
  },
  selectAStore: {
    description: 'shipperHQ select a store dropdown placeholder',
    defaultMessage: 'Select a store',
    id: '2J5LOm',
  },
  placeholderTitle: {
    description: 'ShipperHQ Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'ELt/ut',
  },
  placeholderDescription: {
    description: 'Archives Placeholder Description',
    defaultMessage: 'Error loading ShipperHQ Connections, please try again',
    id: 'MmmUpi',
  },
  placeholderBoldStatusView: {
    description: 'Archives Placeholder Bold Status View Name',
    defaultMessage: 'Connections',
    id: 'Y/CH+1',
  },
  googleStores: {
    description: 'Google Stores Connection list',
    defaultMessage: 'Stores',
    id: 'vS6Xom',
  },
  constantContactLogo: {
    description: 'Constant Contact brand name',
    defaultMessage: 'Constant Contact',
    id: 'Ca7YbW',
  },
  constantContactGetStarted: {
    description: 'link to Constant Contact getting started page',
    defaultMessage: 'If you want to learn more and get started with Constant Contact click <link>here</link>.',
    id: '3gszgn',
  },
  constantContactGrantAccess: {
    description: 'top text for steps to grant access to Constant Contact',
    defaultMessage:
      'Grant ShipStation access to your Constant Contact account by entering your ShipStation API Key and Secret when asked to set up email permissions in Constant Contact. To get your ShipStation API Key and Secret:',
    id: 'DzV+EG',
  },
  constantContactStep1: {
    description: 'step 1 to grant access to Constant Contact',
    defaultMessage: 'Go to <i>Settings > Account > API Settings</i>',
    id: '8TCBmS',
  },
  constantContactStep2: {
    description: 'step 2 to grant access to Constant Contact',
    defaultMessage: 'Click <b>Generate API Keys</b>',
    id: 'j4fQJ1',
  },
  constantContactStep3: {
    description: 'step 3 to grant access to Constant Contact',
    defaultMessage: 'Copy your key and secret',
    id: 'v8P3jP',
  },
  constantContactPermissions: {
    description: 'top text for links about permissions in Constant Contact',
    defaultMessage:
      'Both ShipStation and Constant Contact require you to gather consent from your merchants before you can market to them. Learn more about gathering permissions in Constant Contact:',
    id: 'YTXALl',
  },
  constantContactLink1: {
    description: 'title of first Constant Contact help page',
    defaultMessage: '<link>Send an opt-in email from Constant Contact and import ShipStation Contacts</link>',
    id: 'YlFzai',
  },
  constantContactLink2: {
    description: 'title of second Constant Contact help page',
    defaultMessage: '<link>Import your ShipStation contacts without sending an opt-in email</link>',
    id: '6ssuuN',
  },
  constantContactGuide: {
    description: 'link to helpdesk guide for Constant Contact',
    defaultMessage: 'To learn more about ShipStation’s integration with Constant Contact, check out our <link>integration guide</link>.',
    id: 'NcdnAp',
  },
  integration: {
    description: 'Native product integrations',
    defaultMessage: 'Integration',
    id: 'vNWWMf',
  },
  statusIndicator: {
    description: 'status of integration connection',
    defaultMessage: 'Active',
    id: 'q/udYx',
  },
  actionsHeader: {
    description: 'connect integration or manage settings',
    defaultMessage: 'Actions',
    id: '9r8NwC',
  },
  mailChimpBlurb: {
    description: 'Automatically generate new email subscribers based on orders that have been imported',
    defaultMessage: 'Auto create new email subscribers from imported orders',
    id: 'IBvspf',
  },
  quickBooksBlurb: {
    description:
      'Synchronize the data related to your shipped orders with QuickBooks to ensure that your financial records and inventory management are accurately updated and reflect the most recent transactions',
    defaultMessage: 'Sync your shipped order data with Quickbooks',
    id: 'd6xj1I',
  },
  zapierBlurb: {
    description:
      'Effortlessly integrate and synchronize data between various web applications using Zapier, enabling smooth and automatic data transfer and workflow automation',
    defaultMessage: 'Seamlessly connect data between web apps',
    id: 'j9tqX0',
  },
  returnRabbitBlurb: {
    description:
      'Enhance and optimize the post-purchase experience for your Shopify customers by utilizing ReturnRabbit, which streamlines the process for handling returns and exchanges',
    defaultMessage: 'Streamline your Shopify post purchase experience',
    id: '+OL7nj',
  },
  constantContactBlurb: {
    description:
      'Compose and dispatch personalized emails to your customers using Constant Contact, a powerful email marketing platform that allows you to design tailored email campaigns',
    defaultMessage: 'Create and send emails to your customers',
    id: '+QL/IM',
  },
  edeskBlurb: {
    description:
      'Efficiently handle and address customer inquiries using eDesk, a comprehensive customer support platform that enables you to manage communication across multiple channels, organize and prioritize incoming messages',
    defaultMessage: 'Manage and respond to customer inquiries',
    id: 'SMnRvB',
  },
  gorgiasBlurb: {
    description:
      'Transmit detailed information regarding orders and shipment statuses to the Gorgias help desk system, facilitating a more streamlined and efficient customer support process',
    defaultMessage: 'Send order and shipment data to Gorgias help desk',
    id: 'HAk2SP',
  },
  webhooksBlurb: {
    description:
      'Set up notifications to inform your custom applications whenever specific actions or events take place by utilizing Webhooks.',
    defaultMessage: 'Alert your custom applications when certain actions occur',
    id: 'SOK2x/',
  },
  shipperHQBlurb: {
    description:
      'Enhance and refine your shipping cost calculations by utilizing ShipperHQ, a comprehensive shipping rate management platform',
    defaultMessage: 'Optimize your shipping rates with ShipperHQ',
    id: 'XVtXQk',
  },
  googleBlurb: {
    description:
      "Leverage Google's tools and services to streamline and organize your shipping workflow, enabling more efficient management of your logistics processes",
    defaultMessage: 'Utilize Google Shipping Data to calculate shipping speeds',
    id: '0Ai2dk',
  },
  amazonBlurb: {
    description:
      'Amazon provides a comprehensive marketplace platform that assists you in managing and addressing customer inquiries efficiently',
    defaultMessage: 'Amazon is a marketplace that helps you manage and respond to customer inquiries.',
    id: '5lrLcf',
  },
});

export default messages;
